import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction, getAction, deleteAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
import newMap from '@comp/Map/newMap';
import MapGetPoint from '@/components/Map/MapGetPoint';
import explainModal from "../components/explainModal.vue";
var columns2 = [{
  title: '检查内容',
  dataIndex: 'name',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  title: '检测值类型',
  dataIndex: 'category',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'category'
  }
}, {
  title: '文本框类型',
  dataIndex: 'textBox',
  align: 'center',
  width: '12%',
  scopedSlots: {
    customRender: 'textBox'
  }
}, {
  title: '默认值',
  dataIndex: 'defaultValue',
  align: 'center',
  width: '12%',
  scopedSlots: {
    customRender: 'defaultValue'
  }
}, {
  title: '附件',
  dataIndex: 'fileUpload',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'fileUpload'
  }
}, {
  title: '状态',
  dataIndex: 'status',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'status'
  }
}, {
  title: '排序号',
  dataIndex: 'sort',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'sort'
  }
}];
var data2 = [];
export default {
  name: 'PointModal',
  components: {
    newMap: newMap,
    MapGetPoint: MapGetPoint,
    explainModal: explainModal
  },
  data: function data() {
    return {
      title: '操作',
      visible: false,
      disableSubmit: false,
      model: {},
      mapCenter: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 6
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 3
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 20
        }
      },
      columns2: columns2,
      data2: data2,
      latitude: '',
      longitude: '',
      coordinate: '',
      addData2Index: 1,
      confirmLoading: false,
      form_fields: ['pid', 'templateId', 'name', 'status', 'file_upload', 'sort', 'remark'],
      form: this.$form.createForm(this),
      validatorRules: {
        sort: {
          rules: [{
            required: true,
            message: '请输入排序号!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择状态!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入当前列名称!'
          }]
        },
        longitude: {
          rules: [{
            required: true,
            message: '请选择预设坐标!'
          }]
        }
      },
      url: {
        add: '/om/inspection/template/point',
        item: '/om/inspection/template/item/find/',
        deleteItem: '/om/inspection/template/item/deleteFlag'
      }
    };
  },
  created: function created() {
    console.log(this.model);
  },
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      console.log('111', record);
      var that = this;
      that.data2 = [];
      that.form.resetFields();

      if (record.coordinate) {
        var item = record.coordinate.split(',');
        setTimeout(function () {
          that.form.setFieldsValue({
            longitude: item[0]
          });
          that.form.setFieldsValue({
            latitude: item[1]
          });
        }, 300);
      } else if (record.coordinate == null) {
        record.coordinate = '';
      }

      that.model = Object.assign({}, record);
      that.visible = true;
      var last = {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: {
          customRender: 'operation'
        }
      };
      that.columns2.splice(7);

      if (this.disableSubmit == false) {
        that.columns2.push(last);
      }

      if (that.model.status) {
        that.model.status = that.model.status.toString();
      }

      if (record.id != null) {
        that.loadItems(record.id);
        that.form.setFieldsValue({
          docName: record.docName
        });
      }

      this.$nextTick(function () {
        that.form.setFieldsValue(pick(that.model, that.form_fields));
      });
    },
    loadItems: function loadItems(params) {
      var _this = this;

      getAction(this.url.item + params).then(function (res) {
        if (res.success) {
          var itemList = [];

          for (var i = 0; i < res.result.length; i++) {
            var item = res.result[i];
            item.status = item.status.toString();
            item.fileUpload = item.fileUpload.toString();
            item.category = item.category.toString();
            item.key = item.id;
            itemList.push(item);
          }

          _this.data2 = itemList;
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      that.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';

          if (!_this2.model.id) {
            httpurl += _this2.url.add;
            method = 'post';
          } else {
            httpurl += _this2.url.add;
            method = 'put';
          }

          var formData = Object.assign(that.model, values);
          formData.itemList = that.data2;
          formData.delFlag = 0;
          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    // 检查内容增加
    checkAdd: function checkAdd() {
      var checkItem = {
        key: 'A4_' + this.addData2Index,
        category: '',
        textBox: '',
        name: '',
        defaultValue: '',
        sort: '',
        fileUpload: '',
        status: '',
        editable: true
      };
      this.data2.push(checkItem);
      this.addData2Index = this.addData2Index + 1;
    },
    // 检查内容删除
    checkDel: function checkDel(record) {
      var that = this;
      var newData = this.data2.filter(function (item) {
        return record.key == item.key;
      });
      this.data2 = newData;
      deleteAction(that.url.deleteItem, {
        id: this.data2[0].id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadItems(record.pointId);
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    // 检查内容监听
    checkChange: function checkChange(value, key, column) {
      var newData = _toConsumableArray(this.data2);

      var target = newData.filter(function (item) {
        return key === item.key;
      })[0];

      if (target) {
        target[column] = value;
        this.data2 = newData;
      }
    },
    longitudeChange: function longitudeChange() {
      // debugger

      /* 坐标回传给组件 回显*/
      var item = this.model.coordinate.split(',');

      if (typeof item[0] != 'undefined' && typeof item[1] != 'undefined') {
        this.mapCenter = [item[0], item[1]];
      }

      this.$refs.mapForm.show(this.mapCenter);
    },

    /* 坐标赋值给表单 */
    coordinateOk: function coordinateOk(value) {
      // debugger
      if (value != null) {
        var lg = value[0] ? value[0] : null;
        var lt = value[1] ? value[1] : null;
        this.form.setFieldsValue({
          longitude: lg
        });
        this.form.setFieldsValue({
          latitude: lt
        });
        this.model.coordinate = lg + ',' + lt;
      }
    },
    // 巡检说明点击事件
    selectDocld: function selectDocld() {
      this.$refs.explainModal.visible = true;
      this.$refs.explainModal.category = 19;
      this.$refs.explainModal.loadData();
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      console.log('productList', productList);
      this.form.setFieldsValue({
        docName: productList[0].title
      });
      this.$set(this.model, 'docId', productList[0].id);
      this.$forceUpdate();
    }
  }
};